import type { MeContext } from '@serota/domain';

/** Kiracı tipine göre portal: servis firması → Operasyon (/operasyon), kurum → Kurum (/kurum). */
export function homeFor(c: MeContext): string {
  const t = c.active?.tenantType ?? c.memberships[0]?.tenantType;
  return t === 'INSTITUTION' ? '/kurum' : '/operasyon';
}
